import React from 'react';
import AppImage from '../AppImage';
import { useAuth } from '../../contexts/AuthContext';
import Icon from '../AppIcon';
import Button from './Button';



const Header = () => {
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
      // Optionally redirect or show success message
    } catch (error) {
      console.log('Sign out error:', error);
    }
  };

  return (
    <header className="bg-surface border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-4 py-1">
        <div className="flex items-center justify-between h-16">
          {/* Logo and Brand */}
            <div >
              <AppImage
                src="/assets/images/solvarsity-text.png"
                alt="Solvarsity"
                className="h-12 w-auto"
              />
              {/* <span className="text-xl font-bold text-foreground">Solvarsity</span> */}
            </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="https://learning.solutioneers.in/login" className="text-text-secondary hover:text-foreground transition-colors">
              Sign In
            </a>
            <a href="https://solvarsity.solutioneers.in/" className="text-text-secondary hover:text-foreground transition-colors">
              Home
            </a>
          </nav>

          
        </div>
      </div>
    </header>
  );
};

export default Header;